export default __webpack_public_path__ + "static/media/monthy_subs.dbfadaf2.png";